import store from "@/store";
import { linkHorizontal, scaleOrdinal } from "d3";
import { hierarchy, tree } from "d3-hierarchy";
import colors from "@/services/colors";

import { deepCopy } from "../../../services/helpers";

class Tree {

	constructor (id, timeline) {

		this.timeline = timeline;
    
		this.languages = [];
    
		this.timelineSongLookup = {};

		this.timeline.songs.all.forEach(s => {
			this.timelineSongLookup[s.id] = s;
		});

		this.margin = {
			left: 30,
			top: 26,
			right: 30,
			bottom: 30
		};
        
		this.padding = {
			x: 40,
			y: 70
		};

		this.id = id;
		this.song = null;
    
		this.nodes = [];
		this.links = [];
        
		this.getSongHierarchy();

		this.diagonal = linkHorizontal()
			.x(d => d.x)
			.y(d => d.y);

		this.tree = tree();

		let size = this.findSize(this.song);
		this.height = size.height;
		this.width = size.width;

		this.tree = tree()
			.size([this.width, this.height])
			.separation((a,b) => {
				return a.parent == b.parent ? 1: 2;
			});

		this.update(this.song);
	}

	getSongHierarchy () {

		let song = this.getSongById(this.id);

		if (song !== null) {

			// Find origin
			let iteration = 0;
			let parent = song;
			while (parent.parent_id != "" && iteration < 10) {
				iteration++;
				parent = this.getSongById(parent.parent_id);
			}

			// Find all childs
			this.findSongChildren(parent);
			this.song = deepCopy(parent);
		}
	}

	findSongChildren (song) {

		let children = deepCopy(Object.values(store.state.songs)
			.filter(s => s.parent_id == song.id))
			.sort((a,b) => (a.year > b.year) ? 1 : -1);

		if (children.length > 0) {
			song.children = children;
			song.children.forEach(child => {
				this.findSongChildren(child);
			});
		}
	}

	getSongById(id) {
		let song = store.state.songs[id];

		if (song !== undefined) {
			return song;
		}

		return null;
	}

	findSize (root) {
		let treeRoot = hierarchy(root);
		this.tree(treeRoot);
		this.nodes = treeRoot.descendants();

		let maxDepth = 0;
		let depths = {};

		this.nodes.forEach(n => {

			if (depths[n.depth] === undefined) {
				depths[n.depth] = {
					count: 1,
					depth: n.depth
				};
			} else {                
				depths[n.depth].count++;
			}
      
			if (n.depth > maxDepth) {
				maxDepth = n.depth;
			}
		});
    
		depths = Object.values(depths).sort((a,b) => {
			if (a.count > b.count) {
				return -1;
			}
			if (b.count > a.count) {
				return 1;
			}
			return 0;
		});

		return {
			height: maxDepth * this.padding.y,
			width: depths[0].count * this.padding.x
		};
	}

	update (root) {
		let treeRoot = hierarchy(root);
		this.tree(treeRoot);

		this.nodes = treeRoot.descendants().map(node => {
			if (this.timelineSongLookup[node.data.id] !== undefined) {
				node.data.level = this.timelineSongLookup[node.data.id].level;
			}
			return node;
		});
		this.links = treeRoot.links();
    
		this.languages = [];
    
		this.nodes.forEach(node => {
			if (!this.languages.includes(node.data.language) && node.data.language) {
				this.languages.push(node.data.language);
			}
		});
    
		this.color = scaleOrdinal().domain(this.languages).range(colors); 
	}
}

export { Tree };
